export default __webpack_public_path__ + "static/media/Woblii-2.2d918450.jpg";